import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { Button } from "../components/ui/button"
import { Menu, X, ChevronDown } from "lucide-react"

export function HeaderNav() {
  const [isOpen, setIsOpen] = useState(false)
  const [activeSubmenu, setActiveSubmenu] = useState(null)
  const [activeNestedSubmenu, setActiveNestedSubmenu] = useState(null)
  const [menuItems, setMenuItems] = useState([])

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
      document.body.style.position = 'fixed'
      document.body.style.width = '100%'
    } else {
      document.body.style.overflow = 'unset'
      document.body.style.position = 'unset'
      document.body.style.width = 'unset'
    }
    return () => {
      document.body.style.overflow = 'unset'
      document.body.style.position = 'unset'
      document.body.style.width = 'unset'
    }
  }, [isOpen])

  useEffect(() => {
    const handleClickOutside = (event) => {
      const target = event.target
      if (isOpen && !target.closest('[data-menu="true"]')) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [isOpen])

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsOpen(false)
      }
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const toggleSubmenu = (menu) => {
    setActiveSubmenu(activeSubmenu === menu ? null : menu)
  }

  const toggleNestedSubmenu = (menu) => {
    setActiveNestedSubmenu(activeNestedSubmenu === menu ? null : menu)
  }

useEffect(() => {
  fetch("https://pranaam.pranaamhospitals.in/wp-json/pranaam/v1/menu/header")
    .then((res) => res.json())
    .then((data) => {
      const formatHref = (url, title) => {
        // Special case for Maternity Matters - redirect to external site
        if (title && title.toLowerCase().includes('maternity matters')) {
          return 'https://maternity.pranaamhospitals.com/'
        }
        
        if (!url || url === '' || url === 'home' || url === '/') return '/'
        if (url.startsWith('http://') || url.startsWith('https://')) {
          // For other external URLs, keep them as external
          return url
        }
        return url.startsWith('/') ? url : `/${url}`
      }

      const formattedMenu = data.map((item) => ({
        name: item.title,
        href: formatHref(item.url, item.title),
        submenu:
          item.subItems && item.subItems.length > 0
            ? item.subItems.map((sub) => ({
                name: sub.title,
                href: formatHref(sub.url, sub.title),
              }))
            : null,
      }))

      setMenuItems(formattedMenu)
    })
    .catch((err) => console.error("Menu API error:", err))
}, [])

  return (
    <>
      <nav className="hidden md:flex items-center space-x-6" data-menu="true">
        {menuItems.map((item) => (
          <div key={item.name} className="relative group">
            {item.submenu ? (
              <>
                <button
                  className="flex items-center text-sm font-medium hover:text-primary"
                  onClick={() => toggleSubmenu(item.name)}
                >
                  {item.name}
                  <ChevronDown className="w-4 h-4 ml-1" />
                </button>
                {/* <div className="absolute left-0 z-10 w-[45rem] mt-2 origin-top-left bg-white rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 whitespace-nowrap"> */}
                <div
                  className={`absolute left-0 z-10 mt-2 origin-top-left bg-white rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 whitespace-nowrap ${
                    item.name === "Services"
                      ? "w-[45rem]"
                      : "w-[15rem]"
                  }`}
                >
                  <div className="py-1">
                    <div
                      className={`p-2 gap-y-0 w-full max-w-5xl ${
                        item.name === "Services"
                          ? "grid grid-cols-3 gap-x-[6rem]"
                          : "grid grid-cols-1"
                      }`}
                    >
                    {item.submenu.map((subitem) => (
                      <div key={subitem.name} className="relative group/nested">
                        {subitem.submenu ? (
                          <>
                            <div className="flex items-center justify-between px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-primary">
                              <span>{subitem.name}</span>
                              <ChevronDown className="w-3 h-3 ml-1" />
                            </div>
                            <div className="absolute left-full top-0 z-20 w-48 origin-top-left bg-white rounded-md shadow-lg opacity-0 invisible group-hover/nested:opacity-100 group-hover/nested:visible transition-all duration-300">
                              <div className="py-1">
                                {subitem.submenu.map((nestedItem) => (
                                  <Link
                                    key={nestedItem.name}
                                    to={nestedItem.href}
                                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-primary"
                                  >
                                    {nestedItem.name}
                                  </Link>
                                ))}
                              </div>
                            </div>
                          </>
                        ) : (
                          subitem.href.startsWith('http') ? (
                            <a
                              href={subitem.href}
                              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-primary"
                            >
                              {subitem.name}
                            </a>
                          ) : (
                            <Link
                              to={subitem.href}
                              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-primary"
                            >
                              {subitem.name}
                            </Link>
                          )
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                </div>
              </>
            ) : (
              item.href.startsWith('http') ? (
                <a href={item.href} className="text-sm font-medium hover:text-primary">
                  {item.name}
                </a>
              ) : (
                <Link to={item.href} className="text-sm font-medium hover:text-primary">
                  {item.name}
                </Link>
              )
            )}
          </div>
        ))}
      </nav>

      <div className="md:hidden order-last">
        <Button
          variant="ghost"
          size="icon"
          className="relative z-999"
          onClick={() => setIsOpen(!isOpen)}
          aria-expanded={isOpen}
          aria-label="Toggle menu"
          data-menu="true"
          style={{ zIndex: 999 }}
        >
          <span className="sr-only">Toggle menu</span>
          {isOpen ? <X className="w-5 h-5 z-999" /> : <Menu className="w-5 h-5" />}
        </Button>
      </div>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-40 bg-black/50 md:hidden"
            style={{ top: '64px' }}
            aria-hidden="true"
            onClick={() => setIsOpen(false)}
          />
          <div
            className="fixed top-16 right-0 w-full max-w-sm h-[calc(100vh-4rem)] bg-white shadow-xl p-6 overflow-y-auto z-50 md:hidden"
            onClick={(e) => e.stopPropagation()}
            data-menu="true"
          >
            <nav className="flex flex-col space-y-4">
              {menuItems.map((item) => (
                <div key={item.name} className="border-b border-gray-100 pb-2">
                  {item.submenu ? (
                    <div>
                      <button
                        className="flex items-center justify-between w-full text-left text-sm font-medium py-2"
                        onClick={() => toggleSubmenu(item.name)}
                      >
                        {item.name}
                        <ChevronDown
                          className={`w-4 h-4 transition-transform ${activeSubmenu === item.name ? "rotate-180" : ""}`}
                        />
                      </button>
                      {activeSubmenu === item.name && (
                        <div className="ml-4 mt-2 space-y-2">
                          {item.submenu.map((subitem) => (
                            <div key={subitem.name}>
                              {subitem.submenu ? (
                                <>
                                  <button
                                    className="flex items-center justify-between w-full text-left text-sm py-2 text-muted-foreground hover:text-primary"
                                    onClick={() => toggleNestedSubmenu(subitem.name)}
                                  >
                                    {subitem.name}
                                    <ChevronDown
                                      className={`w-3 h-3 transition-transform ${activeNestedSubmenu === subitem.name ? "rotate-180" : ""}`}
                                    />
                                  </button>
                                  {activeNestedSubmenu === subitem.name && (
                                    <div className="ml-4 mt-1 space-y-2">
                                      {subitem.submenu.map((nestedItem) => (
                                        <Link
                                          key={nestedItem.name}
                                          to={nestedItem.href}
                                          className="block py-2 text-sm text-muted-foreground hover:text-primary"
                                          onClick={() => setIsOpen(false)}
                                        >
                                          {nestedItem.name}
                                        </Link>
                                      ))}
                                    </div>
                                  )}
                                </>
                              ) : (
                                subitem.href.startsWith('http') ? (
                                  <a
                                    href={subitem.href}
                                    className="block py-2 text-sm text-muted-foreground hover:text-primary"
                                    onClick={() => setIsOpen(false)}
                                  >
                                    {subitem.name}
                                  </a>
                                ) : (
                                  <Link
                                    to={subitem.href}
                                    className="block py-2 text-sm text-muted-foreground hover:text-primary"
                                    onClick={() => setIsOpen(false)}
                                  >
                                    {subitem.name}
                                  </Link>
                                )
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    item.href.startsWith('http') ? (
                      <a
                        href={item.href}
                        className="block py-2 text-sm font-medium hover:text-primary"
                        onClick={() => setIsOpen(false)}
                      >
                        {item.name}
                      </a>
                    ) : (
                      <Link
                        to={item.href}
                        className="block py-2 text-sm font-medium hover:text-primary"
                        onClick={() => setIsOpen(false)}
                      >
                        {item.name}
                      </Link>
                    )
                  )}
                </div>
              ))}
            </nav>
          </div>
        </>
      )}
    </>
  )
}